import Stack from 'react-bootstrap/Stack';
import domainNameLookup from '../utils/domainNameLookup.js';

function NavLinkIcon(props) {
    
    const iconClassLookup = {
        transportation: 'las la-car',
        electricity: 'las la-bolt',
        energy: 'las la-sun',
        non_renewable_energy: 'las la-burn',
        renewable_energy: 'las la-solar-panel',
        energy_efficiency: 'las la-lightbulb'
    }

    return (
        <Stack className="col-md-5 mx-auto">
            <i style={{fontSize: 48, textAlign: 'center'}} className={iconClassLookup[props.domain]}></i>
            <p style={{fontSize: 16, textAlign: 'center'}}>{domainNameLookup[props.domain]}</p>
        </Stack>
    );

}

export default NavLinkIcon;